import {KeyValueField} from "../../graphql/graphql";

export const cleanKeyValue = (keyValues: KeyValueField[]) => {
    return (keyValues || []).map(({key, value}) => ({key, value}));
};
